import _com from "../../assets/js/common";
import jsonp from "../../assets/js/http";

import { Component, Vue } from "vue-property-decorator";

@Component
export default class broadList extends Vue {
	name: string = "no";
	listData: any = null; //直播间列表数据
	api: any = {
		broadListApi: "//ustatic" + process.env.VUE_APP_URI_ULECDNDOMAIN + "/live/tv/static/yxAndLsBoFangRooms", //获取直播间列表
	};
	isLoading: boolean = false;
	isShowLoading: boolean = true;
	browser = _com.browser();
	source: any = "";
	mounted() {
		this.source = this.$route.params.source || "usq";
		this.getBroadList();
	}
	getBroadList() {
		let tvTypes: any = {
			usq: 3,
			ule: 4,
			uxd: 5,
			uzg: 1
		};
		let callback = `getRooms`;
		let url = `${this.api.broadListApi}/${tvTypes[this.source] || 3}/${Math.floor(new Date().getTime() / 5000)}/${callback}`;
		jsonp(url, {
			jsonp: callback,
			jsonpcallback: callback
		}).then((data: any) => {
			data = data || [];
			this.isLoading = false;
			this.isShowLoading = false;
			
			if(data.length == 1){
				if(sessionStorage.getItem("back")){
					sessionStorage.removeItem("back")
					location.href = 'ULEMOBILE://ulePopView';
				}else{
					this.$router.push({
						path: `/broadLive/${data[0].id}/${data[0].roomNumber}`,
					});
				}
			}else {
				this.listData = data;
			}
			
		});
	}
	toDetail(item: any) {
		// if (!item.tvStatus) {
		// 	//tvStatus 0  为开播  1 已开播
		// 	this.$toast({
		// 		message: "该房间未开播，请稍后再来看看吧",
		// 		className: "topIndex",
		// 		position: "bottom",
		// 		duration: 2000,
		// 	});
		// 	return false;
		// }
		// 
		let path;
		if(window.location.href.indexOf('ylxdFlag=1') > -1) {
			path = `/broadLive/${item.id}/${item.roomNumber}?ylxdFlag=1`
		}else{
			path = `/broadLive/${item.id}/${item.roomNumber}`
		}
		this.$router.push({
			path,
		});
	}
	loadTop() {
		this.getBroadList();
	}
	onClickLeft() {
		if (!document.referrer) {
            if (this.browser.ule || this.browser.ylxd || this.browser.ylxdsq || this.browser.yzg || this.browser.yzgxd) {
                // APP里，退出页面
                location.href = 'ULEMOBILE://ulePopView';
            } else if (this.browser.ulexcx) {
                // 邮乐商城小程序里
                (<any>window).wx.miniProgram.navigateBack({})
            } else if (this.browser.uxdxcx) {
                // 邮乐小店小程序里，还没开发
				(<any>window).wx.miniProgram.navigateBack({})
            } else if (this.browser.usqxcx || this.source == 'usq') {
                // 邮乐优鲜小程序 或 优鲜H5，返回到优鲜首页
                location.href = '//h5'+ this.domain +'/yxd/community/'
            }else if (this.source == 'uzg') { 
                location.href = '//www'+ this.domain +'/app/yzg/wholesale_h5/index.html'
            }else {
                // 默认返回到M站首页
                location.href = '//m'+ this.domain +'/'
            }
        } else {
            history.back();
        }
	}
}
